import React from 'react';
import Recipient from '../../utils/tabs/recipient/Recipient';

/**
 * Affiche le composant d'information sur les produits du colis dans le drawer
 * de la section Expéditions
 */
const RecipientTab = () => (
  <div>
    <Recipient updateOnlyCommandAddress canGenerateReturnLabel />
  </div>
);

export default RecipientTab;
